import { MailNotificationsService } from "../api/services/MailNotificationsService";
import { NotificationTemplatesService } from "../api/services/NotificationTemplatesService";

const substituteTags = (templateStr: string, context: Record<string,string>) =>
  templateStr.replace(/<<(\w+)>>/g, (_, tag) => context[tag] || "");

export const sendNotification = async (
  templateName: string,
  requestId: string,
  user: { name?: string; email?: string } | null,
  toCC: string,
  service: string,
  extraContext: Record<string, string> = {}
) => {
  // 1. Fetch template
  const template = await NotificationTemplatesService.getNotificationByNameServiceRequestsNotificationTemplatesByNameNameGet(templateName);

  // 2. Build base + extra context
  const baseContext: Record<string, string> = {
    RequestId: String(requestId ?? ""),
    RequestorName: user?.name ?? "",
    RequestorEmail: user?.email ?? "",
    ServiceName: service,
    SupportEmail: "connect@7hillslab.com",
    SupportPhone: "+91-XXXXXXXXXX",
    RequestPortalLink: `${window.location.origin}/service-requests/${requestId}`,
  };

  const context = { ...baseContext, ...extraContext };

  // 3. Substitute tags
  const subject = substituteTags(template.subject ?? "", context);
  const bodyHtml = substituteTags(template.body, context);
  // console.log("To Address:", user?.email);
  // 4. Send mail
  await MailNotificationsService.sendMailEndpointMailSendPost(
    {
    to_email: user?.email ?? "",
    subject,
    body_text: bodyHtml,
    cc_mail: toCC ? [toCC] : [],
  }
  )

  console.info(`📧 Mail sent with template ${templateName}`);
};